import React, { useState, useEffect } from 'react';
import "./about.css";
import image from "../../assets/painter_wo_background.png"
import { LuMouse } from "react-icons/lu";
import logo from "../../assets/work1.jpg"
import blob from "../../assets/blob.svg"
import BlobAnimation from '../blob/bloblanimation';



const About = () => {
  return (
    <section className="about section" id="about">
      <div className="about__container grid">
              <div className='about__title__and__buttons'>
                <div className='about__titles'>
                  <h2 className="about__section__title">Building Excellence in Painting services </h2>
                  <h2 className='about__section__subtitle'>Your satisfaction is our priority</h2>
                </div>
              </div>
          <div className='about__logo'>
            <BlobAnimation/>
            <img src={image} alt="" className="about__img" />
         </div>
        </div>
        <div className='about__buttons_background'>
        <div className='about__buttons'>
                    <a href="#contact" className="button__white about__button">
                                Contact us
                    </a>
                    <a href="#business" className="button__white about__button">
                                Scroll down
                                <LuMouse className='mouse__icon' />
                    </a>
          </div>
          </div>
    </section>
  )
}

export default About
